<template>
    <div class="popBg" v-if="state">
        <div class="popBox" :style="{width: width}" ref="popBox">
            <el-card class="box-card">
                <div slot="header" class="title clearfix">
                    <slot name="title"><span v-html="title"></span></slot>

                </div>
                <div class="popBody" ref="popBody" :style="{maxHeight: bodyMaxHeight}">
                    <div class="body">
                        <slot></slot>
                    </div>
                </div>
                <div class="popFoot" v-if="showFoot">
                    <slot name="foot"></slot>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    // import obj from "@/js/obj";
    export default {
        name: "PopForm"
        ,model: {
            prop: "state",
            event: "stateChange"
        }
        ,props: {
            title: {
                type: String,
                default: ""
            },
            width: {
                type: String,
                default: "500px"
            },
            bodyMaxHeight: {
                type: String,
                default: "300px"
            },
            state: {
                type: Boolean,
                default: true
            },
            showFoot: {
                type: Boolean,
                default: true
            }
        }
        ,mounted: function() {
            // window.onresize = () => {
            //     if(this.state) this.autoHeight();
            // };
        }
        ,methods: {
            autoHeight(){
                //计算top
                let outHeight = window.innerHeight;
                let domHeight = this.$refs.popBox.clientHeight;
                let top = (outHeight - domHeight) / 2;
                if(top < 0) top = 0;

                //计算left
                let outWidth = window.innerWidth;
                let domWidth = this.$refs.popBox.clientWidth;
                let left = (outWidth - domWidth) / 2;

                this.$refs.popBox.style.top = top + "px";
                this.$refs.popBox.style.left = left + "px";

                this.$root.log(top, left);
            }
        }
        ,watch: {
            state(val){
                // if(val) {
                //     this.$nextTick( () => {
                //         this.autoHeight();
                //     });
                // }
            }
        }
    }
</script>

<style scoped>
    .popBg{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999;
        overflow: auto;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-items: center;
    }
    .popBox{
        /*max-height: 100%;*/
        /*overflow: auto;*/

        /*position: absolute;*/
        /*top: 0;*/
        /*left: 0;*/
    }
    .popBox .title{
        font-size: 16px;
        line-height: normal;
    }
    .popBody{
        padding-right: 0px;
        overflow: auto;
    }
    .popBody .body{
        padding: 0 10px 0 10px;
    }
    .popFoot{
        padding-top: 20px;
        text-align: center;
    }
</style>
